import { CashFlowAndPerformanceStatisticsParamsAssetClassesEnum } from "@rentablo/api/apiv1";

export type AssetClass =
  | "holdings"
  | "funds"
  | "etfs"
  | "derivative"
  | "bonds"
  | "crypto"
  | "currencies"
  | "preciousMetals";

// In the order the asset class cards show them.
export const ASSET_CLASSES: AssetClass[] = [
  "holdings",
  "funds",
  "etfs",
  "derivative",
  "bonds",
  "crypto",
  "currencies",
  "preciousMetals",
];

export const isAssetClass = (value: unknown): value is AssetClass =>
  ASSET_CLASSES.some((assetClass) => assetClass === value);

// The investment types behind each asset class card; futures, which hardly
// any depot holds, belong to none. The same codes filter the performance,
// investment and booking endpoints.
export const ASSET_CLASS_INVESTMENT_TYPES = {
  holdings: ["11_stock", "71_massets", "91_managed"],
  funds: ["21_fund"],
  etfs: ["22_etf"],
  derivative: ["51_certos"],
  bonds: ["31_bond"],
  crypto: ["82_crypto"],
  currencies: ["81_fcurr"],
  preciousMetals: ["61_pmetals"],
} as const satisfies Record<
  AssetClass,
  readonly CashFlowAndPerformanceStatisticsParamsAssetClassesEnum[]
>;

export type AssetClassInvestmentType =
  (typeof ASSET_CLASS_INVESTMENT_TYPES)[AssetClass][number];

export const investmentTypesOf = (
  assetClasses: AssetClass[]
): AssetClassInvestmentType[] =>
  assetClasses.flatMap(
    (assetClass) => ASSET_CLASS_INVESTMENT_TYPES[assetClass]
  );
